import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";

export default function LegalPage() {
  return (
    <div className="min-h-screen bg-void font-mono text-ink">
      <Navbar />
      <div className="mx-auto max-w-4xl px-6 py-24 sm:px-10">
        <Link to="/" className="mb-8 inline-block text-[10px] tracking-widest text-cyanx hover:text-white transition-colors">
          &lt; RETURN TO SECTOR 1
        </Link>
        <h1 className="mb-12 font-poster text-4xl text-fog">IMPRESSUM</h1>
        <div className="space-y-8 text-sm leading-relaxed text-fog">
          <section>
            <h2 className="mb-4 text-cyanx">Information in accordance with § 5 TMG:</h2>
            <p>elija naruseviciute</p>
            <p>Moislinger Allee 135</p>
            <p>23558 Lübeck, Germany</p>
          </section>

          <section>
            <h2 className="mb-4 text-cyanx">Represented by:</h2>
            <p>elija naruseviciute</p>
          </section>

          <section>
            <h2 className="mb-4 text-cyanx">Contact:</h2>
            <p>Email: [Your Email Address]</p>
            <p>Phone: [Your Phone Number]</p>
          </section>

          <section>
            <h2 className="mb-4 text-cyanx">VAT ID:</h2>
            <p>VAT Identification Number in accordance with § 27 a Value Added Tax Act:</p>
            <p>[Your VAT ID, if applicable]</p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
